import { atom } from 'recoil';
import { PAGE_SIZE_OPTIONS } from '@/components/inbox/mail-rules/Constants';

const mailRulesTableSelectedPageSize = atom({
    key: 'mailRulesTableSelectedPageSize',
    default: 25 as number,
});

interface PagesSizeType {
    value: number,
    label: string,
}

const mailRulesTablePageSizeOptions = atom({
    key: 'mailRulesTablePageSizeOptions',
    default: PAGE_SIZE_OPTIONS as Array<PagesSizeType>,
});

const selectedMailRules = atom({
    key: 'selectedMailRules',
    default: [] as Array<string>,
});

export {
    mailRulesTableSelectedPageSize, selectedMailRules, mailRulesTablePageSizeOptions,
};
